import { AuthStore } from "./AuthStore.js"
import { GalleryStore } from "./GalleryStore.js"
import { I18nStore } from "./I18nStore.js"
import { ThemeStore } from "./ThemeStore.js"
import { ViewerStore } from "./ViewerStore.js"

export class RootStore {
  authStore: AuthStore
  galleryStore: GalleryStore
  i18nStore: I18nStore
  viewerStore: ViewerStore
  themeStore: ThemeStore

  constructor() {
    this.i18nStore = new I18nStore(this)
    this.authStore = new AuthStore(this)
    this.galleryStore = new GalleryStore(this)
    this.viewerStore = new ViewerStore(this)
    this.themeStore = new ThemeStore(this)
  }
}
